import React from 'react'
import s from './styles.module.scss'
import clsx from 'classnames'
import { WithModificationVariant } from 'src/types'

export const ShoppingCartTopRightDecor: React.FC<WithModificationVariant> = ({ variant }) => (
  <div className={clsx(s.holidayDecoration, variant && s[`holidayDecorationTop_${variant}`])} />
)
